export default {
  ATIVAR_SNACKBAR_GLOBAL(state, data) {
    state.snackbarGlobal = data;
  },
};
